import { ListFieldsType, favoriteFoldersListName } from "src/api/config";
import { Folder, FoldersType } from "src/pages/DashboardPage/acadia/type";

export function modifiedFavoriteFoldersList(data: ListFieldsType["FavoriteFolders"][]): Folder[] {
  let resultsObj: Folder[] = [];

  if (data && data.length > 0) {
    resultsObj = data.map((item) => ({
      id: item.ID,
      title: item.Title,
      count: item.DocumentsCount,
      folder: JSON.parse(item.DocumentsFolder) as FoldersType,
    }));
  }

  return resultsObj;
}
